import React from "react";

// Match http(s) URLs. Includes most safe URL chars but stops at whitespace
// or trailing punctuation that's almost never part of the real URL.
const URL_RE = /(https?:\/\/[^\s<>()]+[^\s<>().,!?;:'"])/gi;

/**
 * Renders a string with any http(s) URLs turned into clickable anchors.
 * Used in post and comment bodies so pasted URLs (token explorers, X
 * posts, charts) become tappable instead of dead text.
 *
 * Anchors open in a new tab with `noreferrer` so we don't leak referrer
 * info from inside the group to whatever the linked site logs.
 */
export default function Linkify({ text, className }) {
  if (!text) return null;
  const parts = String(text).split(URL_RE);
  return (
    <span className={className}>
      {parts.map((part, i) =>
        URL_RE.test(part) ? (
          <a
            key={i}
            href={part}
            target="_blank"
            rel="noreferrer noopener"
            className="pm-linkify"
            onClick={(e) => e.stopPropagation()}
          >
            {part}
          </a>
        ) : (
          <React.Fragment key={i}>{part}</React.Fragment>
        )
      )}
    </span>
  );
}
